import { Check, X } from "@phosphor-icons/react";
import { useI18n } from "@/i18n/I18nContext";

export const passwordRules = (pw) => ({
  length: pw.length >= 10,
  upper: /[A-Z]/.test(pw),
  lower: /[a-z]/.test(pw),
  number: /\d/.test(pw),
});

export const isPasswordStrong = (pw) => Object.values(passwordRules(pw)).every(Boolean);

export default function PasswordChecklist({ password }) {
  const { t } = useI18n();
  const rules = passwordRules(password);
  return (
    <ul data-testid="password-checklist" className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1">
      {Object.entries(rules).map(([k, ok]) => (
        <li key={k} data-testid={`pw-rule-${k}`} data-ok={ok} className={`flex items-center gap-1.5 text-xs transition-colors ${ok ? "text-[#7A8B5C]" : "text-[#6B6A67]"}`}>
          {ok ? <Check size={13} weight="bold" /> : <X size={13} />} {t.pw[k]}
        </li>
      ))}
    </ul>
  );
}
